/**
 * 定义组件的enable和disable属性
 */
export default {
    "tdt-map": [
        "drag",
        "scrollWheelZoom",
        "doubleClickZoom",
        "keyboard",
        "inertia",
        "continuousZoom",
        "pinchToZoom",
        "autoResize"
    ],
    "tdt-marker": ["dragging"],
    "tdt-polyline": ["edit"],
    "tdt-polygon": ["edit"],
    "tdt-rectangle": ["edit"],
    "tdt-circle": ["edit"]
};
